import { buildScopeValues } from '@ion/api/audit-logs/query';

export default function buildPipelineRecordRef(pipeline) {
  return {
    entity: 'pipeline',
    scopeValues: buildScopeValues('pipeline', pipeline),
    displayName: pipeline?.name ?? null,
  };
}
